import {
  useSalesHierarchyLinksTree,
  getSalesHierarchyLinksTreeQueryKey
} from '@r/api/generated/client.ts';
import { useTranslation } from 'react-i18next';
import { useOrvalQueryErrorToast } from '@r/hooks/use-orval-error-toast.ts';

/** Arbre complet (toutes les têtes + sous-arborescences) d'une hiérarchie commerciale. */
export const useSalesHierarchyTree = (hierarchyId: number | undefined | null) => {
  const { t } = useTranslation();
  const treeQuery = useSalesHierarchyLinksTree(hierarchyId, {
    query: {
      queryKey: getSalesHierarchyLinksTreeQueryKey(hierarchyId),
      enabled: hierarchyId != null
    }
  });
  useOrvalQueryErrorToast(treeQuery, t('toast.error.label'));

  const {
    data: tree,
    isLoading: isTreeLoading,
    isSuccess: isTreeSuccess,
    refetch: refetchTree
  } = treeQuery;

  return {
    tree,
    isTreeLoading,
    isTreeSuccess,
    refetchTree
  };
};
